export const isDateValid = (date: Date) =>
	// eslint-disable-next-line no-restricted-globals
	!isNaN(new Date(date).getDate())
